<template>
  <div>
    <v-card>
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex sm6 xs12 d-flex>
            <v-toolbar flat color="white">
              <v-toolbar-title>App campaign reward table</v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <create-campaign-reward
                :unitList="unitList"
                :orderList="orderList"
                :categoryList="categoryList"
                :levelList="levelList"
                :provinceData="provinceData"
              />
            </v-toolbar>
          </v-flex>
          <v-flex sm6 xs12 d-flex>
            <v-layout row wrap>
              <v-flex xs12 d-flex>
                <v-select
                  :items="[
                    { name: 'Messenger', value: 2 },
                    { name: 'Food delivery', value: 1 },
                  ]"
                  item-text="name"
                  label="Category"
                  item-value="value"
                  v-model="filterCategory"
                  clearable
                  style="width: 40%"
                  class="pr-2"
                ></v-select>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search campaign name"
                  single-line
                  hide-details
                  style="width: 60%"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <campaign-reward-table
        :isLoading="isLoading"
        :headers="headers"
        :search="search"
        :filterCategory="filterCategory"
        :campaignList="campaignList"
        :campaignDetail="campaignDetail"
      />
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CampaignRewardTable from "@/components/back-office/CampaignReward/CampaignRewardTable.vue";
import CreateCampaignReward from "@/components/back-office/CampaignReward/CreateCampaignReward.vue";
export default {
  data() {
    return {
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
        },
        {
          text: "Campaign image",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Campaign name(TH)",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Campaign name(EN)",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Highlight(TH)",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Highlight(EN)",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Category",
          align: "center",
          sortable: false,
          value: "",
        },
        { text: "View", align: "center", sortable: false, value: "fat" },
        { text: "Status", align: "center", sortable: false, value: "fat" },
        { text: "Delete", align: "center", sortable: false, value: "fat" },
      ],
      search: "",
      filterCategory: undefined,
      isLoading: false,
      levelList: [
        {
          name: "Standard",
          value: 1,
        },
        {
          name: "Silver",
          value: 2,
        },
        {
          name: "Gold",
          value: 3,
        },
        {
          name: "Platinum",
          value: 4,
        },
        {
          name: "VIP",
          value: 5,
        },
      ],
      categoryList: [
        {
          name: "Food delivery",
          value: 1,
        },
        {
          name: "Messenger",
          value: 2,
        },
        {
          name: "Wellness",
          value: 4,
        },
      ],
      orderList: [
        {
          name: "Food delivery",
          value: 1,
        },
        {
          name: "Messenger",
          value: 2,
        },
      ],
      unitList: [
        {
          name: "%",
          value: 2,
        },
        {
          name: "฿",
          value: 1,
        },
      ],
    };
  },
  components: {
    "campaign-reward-table": CampaignRewardTable,
    "create-campaign-reward": CreateCampaignReward,
  },
  computed: {
    ...mapState({
      campaignList: (state) => state.campaigns.campaignRewardList,
      campaignDetail: (state) => state.campaigns.campaignRewardDetail,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  methods: {},
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "App Campaign Reward",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  async created() {
    this.isLoading = true;
    await this.$store.dispatch("campaigns/getCampaignRewardList");
    await this.$store.dispatch("fetchProvinceBack/getData");
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
</style>